module.exports = __webpack_public_path__ + "img/car_shina2_47.49969b50.jpg";